<!-- 讯飞语音识别 -->
<!-- 依赖：crypto-js、@muguilin/xf-voice-dictation -->
<template>
  <div class="microphone" @click="start">
    <img src="./yuyin.png">
  </div>
</template>

<script>
import { XfVoiceDictation } from '@muguilin/xf-voice-dictation'
import { getConfig } from './sparkConfig'

let times, xfVoice, callbackChace

export default {
  components: {

  },
  data() {
    return {
      isRecording: false,
      lastCallTime: 0,
      status: '',
      msgList: []
    }
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  mounted() {
    this.connectWebSocket()
  },
  beforeDestroy() {
    clearTimeout(times)
    if (this.isRecording) {
      xfVoice.stop()
    }
  },
  methods: {
    // 开始
    start() {
      if (!this.isRecording) {
        navigator.permissions.query({ name: 'microphone'}).then(res => {
          if(res.state === 'granted'){
            this.msgList = []
            xfVoice.start()
            this.isRecording = true
          } else {
            console.error('未开启麦克风权限，或非HTTPS站点')
            this.$message.warning('未开启麦克风权限')
            navigator.mediaDevices.getUserMedia({ audio: true}).then(res => {
              this.start()
            })
          }
        })
      }
      // if (!this.isRecording) {
      //   this.msgList = []
      //   xfVoice.start()
      //   this.isRecording = true
      // }
    },

    // 发送
    send(callback) {
      if (this.isRecording) {
        callbackChace = callback
        if (this.msgList.length) {
          let data = JSON.parse(JSON.stringify(this.msgList))
          callback && callback(data)
        }
        this.stop()
        this.$emit('end')
      }
    },

    // 结束
    stop() {
      this.isRecording = false
      xfVoice.stop()
      this.$emit('end')
    },

    // 打开WebSocket连接
    connectWebSocket() {
      let data = getConfig()
      xfVoice = new XfVoiceDictation({
        ...data,
        onWillStatusChange: (oldStatus, newStatus) => {
          console.log('语音识别状态变更:', {
            oldStatus,
            newStatus
          })
          this.status = newStatus
          if (newStatus == 'init') {
            this.$emit('start')
          }
          if (newStatus == 'end') {
            if (this.isRecording) {
              xfVoice.start()
              this.msgList.push('')
            }
          }
        },
        onTextChange: (text) => {
          if (!this.msgList.length) {
            this.msgList.push('')
          }
          this.msgList[this.msgList.length - 1] = text || ''
          console.log('语音识别结果:', this.msgList)

          if (this.status == 'end') {
            clearTimeout(times)
            times = setTimeout(() => {
              let data = JSON.parse(JSON.stringify(this.msgList))
              callbackChace && callbackChace(data)
            }, 500)
          }
        },
        onError: (error) => {
          console.error('语音识别错误:', error)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.microphone {
  width: 26px;
  height: 26px;
  display: inline-block;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  #audioElement {
    width: 0;
    height: 0;
    visibility: hidden;
    display: block;
  }
}
</style>